import React, { useState } from "react";

import { Fa0, FaPencil, FaUpDown } from "react-icons/fa6";
import { FaCheck, FaMinus, FaPlus, FaTrashAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { putPlusMetrsFetch, putMinusMetrsFetch } from "../../features/action/fetchFabric";
import { FABRIC_BG } from "../../util/tableRip";

export const StripFabric = ({ i, onToggle}) => {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [showPopover, setShowPopover] = useState(null);
  const [popoverValue, setPopoverValue] = useState("");
  const dispatch = useDispatch();

  const handleOpenPopover = (type) => {
    setShowPopover(type);
    setPopoverValue("");
  };

  const handleClosePopover = () => {
    setShowPopover(null);
    setPopoverValue("");
  };

  const handleConfirm = () => {
    if (popoverValue && !isNaN(popoverValue)) {
      if (showPopover === "plus") {
        dispatch(putPlusMetrsFetch(popoverValue, i.fabricName));
      } else if (showPopover === "minus") {
        dispatch(putMinusMetrsFetch(popoverValue, i.fabricName));
      }
      handleClosePopover();
    }
  };

  const handlePopoverKeyPress = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    } else if (e.key === "Escape") {
      handleClosePopover();
    }
  };

  return (
    <React.Fragment>
      <div className="flex flex-row h-[70px] w-[99%] mb-1 text-center rounded-[10px] bg-white border-solid border-2 border-[#dbdbdb] mx-auto">
        <div
          className={`w-[11.36%] ${
            FABRIC_BG[
              Object.keys(FABRIC_BG).find((key) =>
                i.fabricName.toUpperCase().includes(key),
              )
            ] || ""
          } rounded-l-[8px]`}
        >
          <div
            className={`h-[100%] content-center font-rubik font-light text-xl  rounded-l-[8px]`}
          >
            {i.fabricName}
          </div>
        </div>

        <div className="w-[68.9%] content-center">
          <div
            className="flex h-full  justify-between items-center relative"
            style={{
              background: `linear-gradient(to right, 
                 #739D00 ${(i.remaining / i.fullMetrs) * 100}%,
                  #739D00 ${(i.remaining / i.fullMetrs) * 100}%,
                  #739D00 ${(i.remaining / i.fullMetrs) * 100 + 0.4}%,
                   #ffffff ${(i.remaining / i.fullMetrs) * 100 + 0.4}%)`,
            }}
          >
            <p
              className={` font-rubik font-light text-xl px-4 ${(i.remaining / i.fullMetrs) * 100 < 10 || 0 === i.remaining ? "text-[#dbdbdb]" : "text-transparent"}`}
            >
              empty
            </p>
            <div className="flex items-center">
              <p
                className={` font-rubik font-light text-xl ${(i.remaining / i.fullMetrs) * 100 < 50 || 0 === i.remaining ? "text-[#707070]" : "text-white"}`}
              >
                {i.remaining}
              </p>
            </div>
            <p className=" text-[#dbdbdb] font-rubik font-light text-xl px-4">full</p>
          </div>
        </div>
        <button className="w-[5%] content-center">
          <div className="flex h-full font-rubik font-light text-2xl  text-white   justify-center items-center  bg-[#739D00] hover:bg-[#739D00] hover:opacity-50"
          onClick={onToggle}
          >
            <FaUpDown />
          </div>
        </button>
        <div className="w-[5%] content-center relative">
          <button
            onClick={() => handleOpenPopover("plus")}
            className="w-full h-full"
          >
            <div className="flex h-full font-rubik font-light text-2xl text-white justify-center items-center bg-[#739D00] hover:bg-[#739D00] hover:opacity-50 transition-opacity">
              <FaPlus />
            </div>
          </button>

          {showPopover === "plus" && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={handleClosePopover}
              />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 animate-fadeIn">
                <div className="bg-white rounded-lg shadow-2xl border-2 border-[#739D00] p-4 min-w-[200px]">
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full">
                    <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[8px] border-b-[#739D00]"></div>
                  </div>
                  <div className="mb-3">
                    <label className="block text-sm font-rubik font-medium text-gray-700 mb-2">
                      Add meters
                    </label>
                    <input
                      type="number"
                      value={popoverValue}
                      onChange={(e) => setPopoverValue(e.target.value)}
                      onKeyDown={handlePopoverKeyPress}
                      autoFocus
                      placeholder="0.0"
                      className="w-full px-3 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#739D00] font-rubik text-lg transition-colors"
                    />
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={handleConfirm}
                      className="flex-1 bg-[#739D00] text-white px-4 py-2 rounded-md hover:opacity-80 transition-opacity font-rubik font-medium flex items-center justify-center gap-2"
                    >
                      <FaCheck /> OK
                    </button>
                    <button
                      onClick={handleClosePopover}
                      className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 transition-colors font-rubik font-medium"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="w-[5%] content-center relative">
          <button
            onClick={() => handleOpenPopover("minus")}
            className="w-full h-full"
          >
            <div className="flex h-full font-rubik font-light text-2xl text-white justify-center items-center bg-[#739D00] hover:bg-[#739D00] hover:opacity-50 transition-opacity">
              <FaMinus />
            </div>
          </button>

          {showPopover === "minus" && (
            <>
              <div
                className="fixed inset-0 z-40"
                onClick={handleClosePopover}
              />
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50 animate-fadeIn">
                <div className="bg-white rounded-lg shadow-2xl border-2 border-[#FF3D00] p-4 min-w-[200px]">
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-full">
                    <div className="w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-b-[8px] border-b-[#FF3D00]"></div>
                  </div>
                  <div className="mb-3">
                    <label className="block text-sm font-rubik font-medium text-gray-700 mb-2">
                      Reduce meters
                    </label>
                    <input
                      type="number"
                      value={popoverValue}
                      onChange={(e) => setPopoverValue(e.target.value)}
                      onKeyDown={handlePopoverKeyPress}
                      autoFocus
                      placeholder="0.0"
                      className="w-full px-3 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-[#FF3D00] font-rubik text-lg transition-colors"
                    />
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={handleConfirm}
                      className="flex-1 bg-[#FF3D00] text-white px-4 py-2 rounded-md hover:opacity-80 transition-opacity font-rubik font-medium flex items-center justify-center gap-2"
                    >
                      <FaCheck /> OK
                    </button>
                    <button
                      onClick={handleClosePopover}
                      className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 transition-colors font-rubik font-medium"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <button className="w-[5%] content-center">
          <div className="flex h-full font-rubik font-light text-2xl  text-white  justify-center items-center  rounded-r-[8px] bg-[#739D00] hover:bg-[#FF3D00] hover:opacity-70">
            <FaTrashAlt />
          </div>
        </button>
      </div>
    </React.Fragment>
  );
};
